import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const OTPModal = React.memo(({ modalRef, userEmail, onVerifyOTP, onChangeEmail, onClose, isLoading }) => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef([]);

  useEffect(() => {
    const modalElement = modalRef.current;
    
    const handleModalShown = () => {
      if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }
    };

    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', handleModalShown);
      
      return () => {
        modalElement.removeEventListener('shown.bs.modal', handleModalShown);
      };
    }
  }, [modalRef]);

  const handleOtpChange = useCallback((index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      
      if (value && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  }, [otp]);

  const handleKeyDown = useCallback((index, e) => {
    if (e.key === 'Backspace') {
      const newOtp = [...otp];
      
      if (otp[index] === '' && index > 0) {
        newOtp[index - 1] = '';
        setOtp(newOtp);
        inputRefs.current[index - 1]?.focus();
      } else {
        newOtp[index] = '';
        setOtp(newOtp);
      }
    }
  }, [otp]);

  const handlePaste = useCallback((e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text/plain').slice(0, 6);
    
    if (/^\d+$/.test(pastedData)) {
      const newOtp = [...otp];
      pastedData.split('').forEach((char, index) => {
        if (index < 6) {
          newOtp[index] = char;
        }
      });
      setOtp(newOtp);
      
      const nextEmptyIndex = newOtp.findIndex(digit => digit === '');
      const focusIndex = nextEmptyIndex === -1 ? 5 : Math.min(nextEmptyIndex, 5);
      inputRefs.current[focusIndex]?.focus();
    }
  }, [otp]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    const otpString = otp.join('');
    if (otpString.length === 6) {
      onVerifyOTP(userEmail, otpString);
      setOtp(['', '', '', '', '', '']); 
    }
  }, [otp, onVerifyOTP, userEmail]);
const handleChangeEmail = () => {
  onChangeEmail();
  setOtp(['', '', '', '', '', '']); 
}

  const isOtpComplete = useMemo(() => otp.every(digit => digit !== ''), [otp]);

  return (
    <div 
      className="modal fade portfolio-modals-main" 
      ref={modalRef}
      tabIndex="-1"
      aria-labelledby="otpModalLabel"
      aria-hidden="true"      
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-body">
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
              aria-label="Close"
              disabled={isLoading}
            />
            <form onSubmit={handleSubmit} className='portfolio-modals'>
              <h2>Start Hiring with us!</h2>
              <p className='pt-3 mb-0'>
                Please enter the OTP sent to <strong>{userEmail}</strong>
              </p>
              <div className='my-3 my-lg-5 otp-input'>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type='text'
                    name={`otp-${index}`}
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    onPaste={handlePaste}
                    disabled={isLoading}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    autoComplete="off"
                  />
                ))}
              </div>
              <button 
                type="submit"
                className='default-btn blue-bg mb-5'
                disabled={isLoading || !isOtpComplete}
              >
                {isLoading ? 'Verifying...' : 'Verify OTP'}
              </button>
              <p className='d-flex align-items-center justify-content-center'>
                Didn't receive OTP?  
                <button 
                  type="button"
                  className='default-color fw-500 text-decoration-none ms-1 btn btn-link p-0'
                  onClick={() => {}}
                  disabled={isLoading}
                >
                  Resend code
                </button>
              </p>
              <p className='d-flex align-items-center justify-content-center'>
                <button 
                  type="button"
                  className='default-color fw-500 text-decoration-none btn btn-link p-0'
                  onClick={handleChangeEmail}
                  disabled={isLoading}
                >
                  Change Email
                </button>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
});

export default OTPModal;
